import { useMemo, useSyncExternalStore } from 'react';

const getMeasuredHeight = () => {
  const root = document.querySelector('.mod--smartForm.mod--user');
  if (!root) return 0;

  const rootTop = root.getBoundingClientRect().top;
  const elements = [
    root.querySelector('.chat-messages.mod--smartForm.mod--user'),
    root.querySelector('textarea.chat-input'),
  ].filter(Boolean);

  const bottom = elements.reduce(
    (maxBottom, element) =>
      Math.max(maxBottom, element.getBoundingClientRect().bottom),
    rootTop,
  );

  return Math.ceil(bottom - rootTop);
};

const createObserverStore = (isActive) => {
  if (!isActive) {
    return {
      getSnapshot: () => 0,
      subscribe: () => () => {},
    };
  }

  return {
    getSnapshot: () => getMeasuredHeight(),
    subscribe: (onStoreChange) => {
      let frameId = 0;

      const notify = () => {
        window.cancelAnimationFrame(frameId);
        frameId = window.requestAnimationFrame(onStoreChange);
      };

      const observer = new MutationObserver(notify);
      observer.observe(document.body, {
        childList: true,
        subtree: true,
        characterData: true,
      });

      window.addEventListener('resize', notify);
      notify();

      return () => {
        window.cancelAnimationFrame(frameId);
        observer.disconnect();
        window.removeEventListener('resize', notify);
      };
    },
  };
};

const useSmartFormHeight = (isActive) => {
  const store = useMemo(() => createObserverStore(isActive), [isActive]);
  return useSyncExternalStore(store.subscribe, store.getSnapshot);
};

export default useSmartFormHeight;
